import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addBonus, updateBonus } from "../../redux/bonusSlice";
import { fetchEmployees } from "../../redux/employeeSlice";


const BonusDetailModal = ({ isOpen, onClose, initialData }) => {
  const dispatch = useDispatch();
  const { employees, status: employeeStatus } = useSelector((state) => state.employees || { employees: [], status: "idle" });
  const { register, handleSubmit, reset, setValue } = useForm();
  const [error, setError] = useState(null);

 
  useEffect(() => {
    if (employeeStatus === "idle") {
      dispatch(fetchEmployees());
    }
  }, [dispatch, employeeStatus]);

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    } else {
      reset();
      setValue("sessionName", "March-2024"); 
    }
  }, [initialData, setValue, reset]);

  const handleFormSubmit = async (data) => {
    try {
      const bonusData = {
        employeeId: employees.find((emp) => emp.firstName + " " + emp.lastName === data.employeeName)?.id,
        sessionName: data.sessionName,
        applyDate: data.applyDate,
        employeeName: data.employeeName,
        amount: parseFloat(data.duesAmount),
        description: data.description,
        status: initialData ? data.status : "Pending",
      };

      if (initialData) {
        // Update bonus
        await dispatch(updateBonus({ id: initialData.id, updatedData: bonusData })).unwrap();
      } else {
        // Add bonus
        await dispatch(addBonus(bonusData)).unwrap();
      }

      reset();
      onClose();
    } catch (err) {
      setError("Failed to save bonus. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-medium">
            {initialData ? "Edit Bonus for Employee" : "Apply Bonus to Employee"}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit(handleFormSubmit)} className="p-4 space-y-4">
          {error && <p className="text-red-500">{error}</p>}
          <div>
            <label className="block text-sm font-medium">Session Name</label>
            <input
              type="text"
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("sessionName")}
              readOnly
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Apply Date *</label>
            <input
              type="date"
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("applyDate", { required: true })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Employee Name *</label>
            <select
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("employeeName", { required: true })}
            >
              <option value="" disabled>
                Select option
              </option>
              {employees.map((employee) => (
                <option key={employee.id} value={`${employee.firstName} ${employee.lastName}`}>
                  {employee.firstName} {employee.lastName}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Amount *</label>
            <input
              type="number"
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("duesAmount", { required: true })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Description</label>
            <textarea
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("description")}
              placeholder="Enter description"
            ></textarea>
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#231763] text-white px-4 py-2 rounded"
            >
              {initialData ? "Update Bonus" : "Apply Bonus"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BonusDetailModal;